import { StyledLabel } from './styles';

export default StyledLabel;
